import React, { useEffect, useRef, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import '../../../Static/priceinfo.css';
import { selectPaymentData } from '../../Selectors/JobworkSelector/JobworkSelect';
import { fetchPaymentRegister } from '../../../Store/PHPSlice/Payment/paymentApi';


const PaymentView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        payId: Id,
        dt: '',
        fdt: '',
        tdt: '',
        balamt: '',
        bnk_nm: '',
        chq_no: '',
        dedamt: '',
        empId: '',
        empNm: '',
        jobId: '',
        nar: '',
        netAmt: '',
        paidamt: 0,
        payMemo: '',
        pay_mode: '',
        payableamt: ''
    });
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    const [jobwork, setJobwork] = useState([]);

    const [extraAmt, setExtraAmt] = useState([]);
    const paymentlist = useSelector(selectPaymentData);
    // console.log(paymentlist)
    useEffect(() => {
        dispatch(fetchPaymentRegister(Id));
    }, [Id]);

    useEffect(() => {
        if (paymentlist?.data) {
            const data2 = paymentlist?.data;
            setFormData(prev => ({
                ...prev,
                balamt: data2.balamt,
                bnk_nm: data2.bnk_nm,
                chq_no: data2.chq_no,
                dedamt: data2.dedamt,
                dt: data2.dt,
                empId: data2.empId,
                empNm: data2.empNm,
                fdt: data2.fdt,
                jobId: data2.jobId,
                nar: data2.nar,
                netAmt: data2.netamt,
                paidamt: data2.paidamt,
                payMemo: data2.payMemo,
                pay_mode: data2.pay_mode,
                payableamt: data2.payableamt,
                tdt: data2.tdt
            }));
        }

    }, [paymentlist]);


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Tiyara Garment - Payment View</h3>
                        <div className="dashed-line"></div>
                        <h4 className='pay_status'>Payment Status - <span>Paid</span></h4>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px' }}>Payment No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.payMemo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>From Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.fdt}</td>

                                    <td style={{ width: '200px' }}>To Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.tdt}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Employee</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Net Amt.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.netAmt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Deduct Amt.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dedamt}</td>
                                    <td style={{ width: '200px' }}>Payable Amt.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.payableamt}</td>
                                </tr>

                                <tr>

                                    <td style={{ width: '200px' }}>Paid Amt.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.paidamt}</td>
                                    <td style={{ width: '200px' }}>Balance Amt.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.balamt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Payment Mode</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.pay_mode}</td>
                                    <td style={{ width: '200px' }}>Bank Name</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.bnk_nm}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Transaction No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.chq_no}</td>
                                    <td style={{ width: '200px' }}>Naration</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.nar}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
}

export default PaymentView;
